<template>
    <v-snackbar
        v-model="displaySnackbar"
        :color="color"
        :timeout="timeout"
        right
        top
    >
        <ul>
            <li v-for="text in data" :key="text">
                <strong>{{ text }}</strong>
            </li>
        </ul>
        <template #action="{ attrs }">
            <v-progress-circular
                :rotate="-90"
                :size="100"
                :value="value"
                :width="10"
                color="white"
                style="max-height: 30px;"
            >
                <v-btn
                    icon
                    text
                    v-bind="attrs"
                    @click="close"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-progress-circular>

        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: "Snackbar",
    props: {
        display: {
            type: Boolean,
            required: true
        },
        color: {
            type: String,
            required: false,
            default: "success"
        },
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            timeout: 5750,
            value: 100,
        }
    },
    computed: {
        displaySnackbar() {
            return this.display;
        }
    },
    watch: {
        display: {
            handler(value) {
                if (value === true) {
                    this.value = 100;
                    this.timedProgress();
                }
            }
        }
    },
    methods: {
        close() {
            this.$emit('closed');
        },
        timedProgress() {
            this.value = 100
            const timeout = setInterval(() => {
                if (this.value > 0) {
                    this.value -= 10
                }
            }, 500)
            setTimeout(() => {
                clearTimeout(timeout)
                this.close();
            }, this.timeout)
        }
    }
}
</script>
